import Vue from 'vue'

import { cloneDeep, debounce } from 'lodash'

import {
  EVENT_FORM_INTERACTED,
  EVENT_FORM_ERROR
} from '@/config/events'

/**
 * @note: the submit event from personData and adminData has to be catched differently:
 * the component emits an @update, when submit has been triggered manually (by method-call)
 */
class FormTracker {
  constructor (el, vnode, model) {
    this.el = el
    this.vnode = vnode

    this.$EventBus = vnode.context.$EventBus
    this.model = model

    this.interactionTriggered = false

    window.setTimeout(() => this.registerListener(), 500)
  }

  triggerInteraction (event) {
    if (!this.interactionTriggered) {
      debounce(() => this.vnode.context.triggerInteraction(event.target.name), 50)()
      this.interactionTriggered = true
    }
  }

  registerListener () {
    this.elements = Array.from(this.el.querySelectorAll('input, textarea, select'))
    const cancelButtons = Array.from(this.el.querySelectorAll('button[type=cancel]'))

    cancelButtons.forEach(button => {
      button?.addEventListener('click', event => {
        event.preventDefault()
        this.vnode.context.triggerCancel()
      })
    })

    this.elements.forEach(element => {
      element.addEventListener('focus', event => this.triggerInteraction(event))
      element.addEventListener('change', event => this.triggerInteraction(event))
    })
  }
}

export default {
  bind: function (el, binding, vnode) {
    new FormTracker(el, vnode, binding.value)
  }
}
